import { Box, Tab } from '@mui/material';
import { ReactNode } from 'react';

import { SolaForceTabs } from '~/components/SolaForceTabs';
import { useSxStyles } from '~/scenes/PortalModules/Analytics/common/ReportTabsLayout/useStyles';

type PropsType<T> = {
  reportTab: string;
  setReportTab: (value: T) => void;
  tabLabels: { [p: string]: string };
  children: ReactNode;
};

export const ReportTabsLayout = <T,>(props: PropsType<T>) => {
  const { reportTab, setReportTab, tabLabels, children } = props;

  const sxStyles = useSxStyles();

  return (
    <>
      <SolaForceTabs
        value={reportTab}
        onChange={(_event, value) => {
          setReportTab(value);
        }}
        background={'fade'}
      >
        {Object.entries(tabLabels).map(([tab, label]) => {
          const tabProps = {
            id: `report-tab-${tab}`,
            'aria-controls': `report-tabpanel-${tab}`,
            label: `${label}`,
            value: tab,
            key: `report-tab-${tab}`,
          };

          return <Tab {...tabProps}></Tab>;
        })}
      </SolaForceTabs>
      <Box sx={sxStyles.tabContent}>{children}</Box>
    </>
  );
};
